import { useEffect, useRef, useState } from "react";

type Parameters = {
  delay: number;
  callback?: () => void;
};

type ReturnType = [boolean, () => void];

const useLazyTimeout = ({ delay, callback }: Parameters): ReturnType => {
  const [toggle, setToggle] = useState(false);

  const callbackRef = useRef<null | (() => void)>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setToggle(false);
      if (callback) {
        callbackRef.current?.();
      }
    }, delay);

    return () => clearTimeout(timeout);
  }, [toggle, delay]);

  const trigger = () => {
    if (!toggle) {
      setToggle(true);
      if (callback) {
        callbackRef.current = callback;
      }
    }
  };

  return [toggle, trigger];
};

export default useLazyTimeout;
